<template>
  <div class="detail">
    <div style="margin-bottom:24px"><span style="color:#666666;cursor:pointer" @click="toBack">{{ detailBack.name }} </span> > <span style="color: #333;">{{ detailBack.btnName }}</span></div>
    <div class="page-title-box">
      <span class="page-title">{{ detailBack.btnName }}</span>
      <div v-if="detailBack.btn == 'LOOK'">
        <el-button style="width:80px;margin-left:16px" @click="toBack">返回</el-button>
        <!-- <el-button type="primary" style="width:136px;margin-left:16px" @click="sendUpdateOrder">导出确认件</el-button> -->
      </div>
      <div v-if="detailBack.type == 'SEND' && detailBack.btn == 'UPDATE'">
        <el-button style="width:80px;margin-left:16px" @click="toBack">返回</el-button>
        <el-button type="primary" style="width:136px;margin-left:16px" @click="sendUpdateOrder">发送修改报文</el-button>
      </div>
      <div v-if="detailBack.type == 'WAITING' && detailBack.btn == 'EDIT'">
        <el-button style="width:80px;margin-left:16px" @click="toBack">返回</el-button>
        <!-- <el-button type="primary" style="width:136px;margin-left:16px" @click="sendUpdateOrder">导出确认件</el-button> -->
        <el-button type="primary" style="width:80px;margin-left:16px" @click="saveSent">确定</el-button>
      </div>
      <div v-if="detailBack.btn == 'COPY' || detailBack.btn == 'ADD' || detailBack.btn == 'EXPORT'">
        <el-button style="width:80px;margin-left:16px" @click="toBack">返回</el-button>
        <el-button style="width:136px;margin-left:16px;color:#1170EB;border:1px solid #1170EB;" @click="saveSent">保存到待发送</el-button>
        <el-button type="primary" style="width:136px;margin-left:16px" @click="saveDraft">保存到草稿箱</el-button>
      </div>
      <div v-if="detailBack.type == 'DRAFT' &&  detailBack.btn == 'EDIT'">
        <el-button style="width:80px;margin-left:16px" @click="toBack">返回</el-button>
        <el-button style="width:136px;margin-left:16px;color:#1170EB;border:1px solid #1170EB;" @click="saveSent">保存到待发送</el-button>
        <el-button type="primary" style="width:136px;margin-left:16px" @click="saveDraft">保存到草稿箱</el-button>
      </div>

    </div>
    <el-form ref="form" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="true">
      <div class="form-part">提单信息</div>
      <div>
        <el-form-item label="主提单号" prop="masterBillNo">
          <el-input v-model="form.masterBillNo" @blur="blurMasterBillNo" placeholder="请输入主提单号" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" :minlength="6" :maxlength="30" show-word-limit @input="val => toupcaseTable(val, 'masterBillNo')" style="width:320px"></el-input>
        </el-form-item>
        <el-form-item label="船公司" prop="carrier">
          <el-select v-model="form.carrier" @blur="handBlur('carrier')" placeholder="请选择船公司" filterable :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width:320px" @change="changeCarrier">
            <el-option v-for="item in carriersList" :key="item.code" :label="item.nameEn + '-' + item.nameCn" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="客户备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入客户备注" :disabled="getDisabled" style="width:320px" maxlength="30" show-word-limit></el-input>
        </el-form-item>
      </div>
      <div class="form-part">船舶信息</div>
      <div>
        <el-form-item label="船名" prop="shipName">
          <el-input v-model="form.shipName" placeholder="请输入船名" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width:320px" @input="val => toupcaseTable(val, 'shipName')" maxlength="35" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="航次" prop="voyageNo">
          <el-input v-model="form.voyageNo" placeholder="请输入航次" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width:196px" @input="val => toupcaseTable(val, 'voyageNo')" maxlength="10" show-word-limit></el-input>
          <el-button type="primary" class="form-item-btn" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" @click="checkShipPlan">检验航次</el-button>
        </el-form-item>
        <el-form-item label="船代" prop="shipAgent">
          <el-select v-model="form.shipAgent" @blur="handBlur('shipAgent')" placeholder="请选择船代" filterable :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width:196px">
            <el-option v-for="item in agentList" :key="item.code" :label="item.nameCn" :value="item.code" />
          </el-select>
          <el-button type="primary" class="form-item-btn" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" @click="findAgent">查看船代</el-button>
        </el-form-item>
        <el-form-item v-if="imoType" label="IMO编号" prop="imo">
          <el-input v-model="form.imo" placeholder="请输入IMO编号" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" style="width:196px" :minlength="6" :maxlength="11" show-word-limit @input="val => toupcaseTable(val, 'imo')"></el-input>
          <el-button type="primary" class="form-item-btn" :disabled="detailBack.btn == 'UPDATE' ? true : getDisabled" @click="searchImo">查询IMO编号</el-button>
        </el-form-item>
        <div v-else style="width: 100px;"></div>
        <el-form-item label="收货地" prop="porCode">
          <el-select v-model="form.porCode" @blur="handBlur('porCode')" placeholder="请输入收货地" disabled :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPor" @change="changePor" style="width:196px">
            <el-option v-for="item in porList" :key="item.code" :label="item.nameEn" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.show }}</span>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="form.porCode" @blur="handBlur('porCode')" placeholder="五字码" disabled :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPor" @change="changePor" style="width:108px;margin-left:16px">
            <el-option v-for="item in porList" :key="item.code" :label="item.code" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.code }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起运港" prop="polCode">
          <el-select v-model="form.polCode" @blur="handBlur('polCode')" placeholder="请输入起运港" disabled :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPol" @change="changePol" style="width:196px">
            <el-option v-for="item in polList" :key="item.code" :label="item.nameEn" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.show }}</span>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="form.polCode" @blur="handBlur('polCode')" placeholder="五字码" disabled :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPol" @change="changePol" style="width:108px;margin-left:16px">
            <el-option v-for="item in polList" :key="item.code" :label="item.code" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.code }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卸货港" prop="pouCode">
          <el-select v-model="form.pouCode" @blur="handBlur('pouCode')" placeholder="请输入卸货港" :disabled="getDisabled" :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPou" @change="changePou" style="width:196px">
            <el-option v-for="item in pouList" :key="item.code" :label="item.nameEn" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.show }}</span>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="form.pouCode" @blur="handBlur('pouCode')" placeholder="五字码" :disabled="getDisabled" :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPou" @change="changePou" style="width:108px;margin-left:16px">
            <el-option v-for="item in pouList" :key="item.code" :label="item.code" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.code }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="目的港" prop="podCode">
          <el-select v-model="form.podCode" @blur="handBlur('podCode')" placeholder="请输入目的港" :disabled="getDisabled" :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPod" @change="changePod" style="width:196px">
            <el-option v-for="item in podList" :key="item.code" :label="item.nameEn" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.show }}</span>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="form.podCode" placeholder="五字码" :disabled="getDisabled" :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPod" @change="changePod" style="width:108px;margin-left:16px">
            <el-option v-for="item in podList" @blur="handBlur('podCode')" :key="item.code" :label="item.code" :value="item.code">
              <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                <span>{{ item.code }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="form-part">发货人信息</div>
      <el-form ref="shipperForm" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="true">
        <div>
          <el-form-item label="名称" prop="shipperName" style="width:100%">
            <el-input v-model="form.shipperName" :disabled="getDisabled" placeholder="请输入名称，最多70个字符" style="max-width:1040px;width:60%" maxlength="70" show-word-limit @input="val => toupcaseTable(val, 'shipperName')"></el-input>
            <el-link @click="chooseAddress(1)" :disabled="getDisabled" type="primary" :underline="false" class="good-user-link"><i class="iconfont icon-xuanzetongzhiren"></i>选择发货人</el-link>
            <el-link type="primary" :disabled="getDisabled" :underline="false" class="good-user-link" @click="saveCustoms(1)"><i class="iconfont icon-baocuntongzhiren"></i>保存发货人</el-link>
          </el-form-item>
          <el-form-item label="地址" prop="shipperAddress" style="width:100%">
            <el-input type="textarea" :disabled="getDisabled" v-model="form.shipperAddress" placeholder="请输入发货人地址，最多140个字符" style="max-width:1040px;width:60%" maxlength="140" show-word-limit @input="val => toupcaseTable(val, 'shipperAddress')"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="国家代码" prop="shipperCountryCode">
              <el-select v-model="form.shipperCountryCode" :disabled="getDisabled" placeholder="请输入国家代码" filterable @blur="handBlur('shipperCountryCode')" style="width: 320px">
                <el-option v-for="item in countryList" :key="item.code" :label="item.show" :value="item.code">
                  <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                    <span>{{ item.show }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="shipperContactNumber">
              <el-input v-model="form.shipperContactNumber" :disabled="getDisabled" placeholder="请输入发货人电话" style="width:180px" clearable maxlength="20"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="form-part">收货人信息</div>
      <el-form ref="consigneeForm" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="true">
        <div>
          <el-form-item label="名称" prop="consigneeName" style="width:100%">
            <el-input :disabled="getDisabled" v-model="form.consigneeName" placeholder="请输入名称，最多70个字符" style="max-width:1040px;width:60%" maxlength="70" show-word-limit @input="val => toupcaseTable(val, 'consigneeName')"></el-input>
            <el-link :disabled="getDisabled" @click="chooseAddress(2)" type="primary" :underline="false" class="good-user-link"><i class="iconfont icon-xuanzetongzhiren"></i>选择收货人</el-link>
            <el-link :disabled="getDisabled" type="primary" :underline="false" class="good-user-link" @click="saveCustoms(2)"><i class="iconfont icon-baocuntongzhiren"></i>保存收货人</el-link>
          </el-form-item>
          <el-form-item label="地址" prop="consigneeAddress" style="width:100%">
            <el-input :disabled="getDisabled" type="textarea" v-model="form.consigneeAddress" placeholder="请输入收货人地址，最多140个字符" style="max-width:1040px;width:60%" maxlength="140" show-word-limit @input="val => toupcaseTable(val, 'consigneeAddress')"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="国家代码" prop="consigneeCountryCode">
              <el-select v-model="form.consigneeCountryCode" @blur="handBlur('consigneeCountryCode')" :disabled="getDisabled" placeholder="请输入国家代码" filterable style="width: 320px">
                <el-option v-for="item in countryList" :key="item.code" :label="item.show" :value="item.code">
                  <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                    <span>{{ item.show }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="consigneeContactNumber">
              <el-input v-model="form.consigneeContactNumber" :disabled="getDisabled" placeholder="请输入收货人电话" style="width:180px" clearable maxlength="20"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="form-part">通知人信息</div>
      <el-form ref="notifyForm" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="true">
        <div>
          <el-form-item label="名称" prop="notifyName" style="width:100%">
            <el-input :disabled="getDisabled" v-model="form.notifyName" placeholder="请输入名称，最多70个字符" style="max-width:1040px;width:60%" maxlength="70" show-word-limit @input="val => toupcaseTable(val, 'notifyName')"></el-input>
            <el-link :disabled="getDisabled" type="primary" :underline="false" class="good-user-link" @click="copyConsignee"><i class="iconfont icon-fuzhi"></i>复制收货人</el-link>
            <el-link :disabled="getDisabled" @click="chooseAddress(3)" type="primary" :underline="false" class="good-user-link"><i class="iconfont icon-xuanzetongzhiren"></i>选择通知人</el-link>
            <el-link :disabled="getDisabled" type="primary" :underline="false" class="good-user-link" @click="saveCustoms(3)"><i class="iconfont icon-baocuntongzhiren"></i>保存通知人</el-link>
          </el-form-item>
          <el-form-item label="地址" prop="notifyAddress" style="width:100%">
            <el-input :disabled="getDisabled" type="textarea" v-model="form.notifyAddress" placeholder="请输入通知人地址，最多140个字符" style="max-width:1040px;width:60%" maxlength="140" show-word-limit @input="val => toupcaseTable(val, 'notifyAddress')"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="国家代码" prop="notifyCountryCode">
              <el-select v-model="form.notifyCountryCode" @blur="handBlur('notifyCountryCode')" :disabled="getDisabled" placeholder="请输入国家代码" filterable style="width: 320px">
                <el-option v-for="item in countryList" :key="item.code" :label="item.show" :value="item.code">
                  <div style="padding-bottom: 3px; color: #444; font-weight: bold;">
                    <span>{{ item.show }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系电话" prop="notifyContactNumber">
              <el-input v-model="form.notifyContactNumber" :disabled="getDisabled" placeholder="请输入通知人电话" style="width:180px" clearable maxlength="20"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="form-part">货物明细</div>
      <div>
        <div>
          <el-button v-if="detailBack.btn != 'UPDATE'" type="primary" style="width:140px;margin-bottom:24px" @click="addGoodsDetail" :disabled="getDisabled">
            <i class="iconfont icon-xinzenghuowumingxi"></i>
            新增货物明细
          </el-button>
          <div class="goods-list-title">
            <span>总件数：</span>
            <span class="goods-num">{{ getTotalPackages(WTableOpts.data) }}</span>
            <span>总毛重：</span>
            <span class="goods-num">{{ getTotalGrossWeight(WTableOpts.data) }}</span>
            <span>总体积：</span>
            <span class="goods-num">{{ getTotalVolume(WTableOpts.data) }}</span>
          </div>
        </div>
        <WTable :WTableOpts="detailBack.btn == 'LOOK' ? WTableOptsLook : WTableOpts" :operation="false">

          <template #packageUnit="{ row }">
            <span v-if="row.packageUnitSimpleVO">{{ row.packageUnitSimpleVO.code + '-' + row.packageUnitSimpleVO.nameEn + '-' + row.packageUnitSimpleVO.nameCn }}</span>
          </template>

          <template #operation="{ row, $index }">
            <div class="table-btn-box">
              <el-link v-if="detailBack.btn != 'UPDATE'" type="primary" :disabled="getDisabled" :underline="false" @click="copyData(row)">复制</el-link>
              <el-link type="primary" :disabled="getDisabled" :underline="false" @click="editData(row, $index)">编辑</el-link>
              <el-link v-if="detailBack.btn != 'UPDATE'" type="primary" :disabled="getDisabled" :underline="false" @click="deleteData(row, $index)">删除</el-link>
            </div>
          </template>
        </WTable>
      </div>
    </el-form>
    <div style="height: 24px;"></div>

    <GoodsDetail v-if="showGoodsDetail" ref="goodsDetail" :visible.sync="showGoodsDetail" :detailData="goodsDetailData" :isEdit="isEdit" :modifyType="modifyType" @closeDialog="closeDialog" @submitGoods="submitGoods" />
    <Imo v-if="showImo" :visible.sync="showImo" :imoData="imoData" :imoType="imoTypes" @closeDialog="closeDialog" @enterImo="enterImo" />
    <Agent v-if="showAgent" :visible.sync="showAgent" :agentData="agentData" @closeDialog="closeDialog" @chooseAgent="chooseAgent" />
    <Voyage v-if="showVoyage" :visible.sync="showVoyage" :checkShipPlanData="checkShipPlanData" @closeDialog="closeDialog" />
    <Address v-if="showAddress" :visible.sync="showAddress" :addressType="addressType" @chooseSuccess="chooseSuccess" @closeDialog="closeDialog" />
    <UpdateOrderFee v-if="showUpdateOrderFee" :visible.sync="showUpdateOrderFee" :updateOrderFee="updateOrderFee" @closeDialog="closeDialog" @enterSendUpdateOrder="enterSendUpdateOrder" />

  </div>
</template>

<script>
import GoodsDetail from './detail/GoodsDetail'
import Imo from './detail/Imo'
import Agent from './detail/Agent'
import Voyage from './detail/Voyage'
import Address from './detail/Address'
import UpdateOrderFee from './detail/UpdateOrderFee'
import { common, drafts } from "@/api/index";
import { httpAgent } from "@/api/ajax";
var regCN = /[^\x00-\xff]/ig // 检测中文
var regSP = /^\S.*\S$|(^\S{0,1}\S$)/ // 检测空格

export default {
  name: "Detail",
  components: {
    GoodsDetail,
    Imo,
    Agent,
    Voyage,
    Address,
    UpdateOrderFee
  },
  data() {
    const regNum = /^[0-9]+$/
    const regex = /^[0-9A-Z]+$/
		const validateNum = (rule, value, callback) => {
			if (regNum.test(value) === false) {
				callback(new Error('只能输入数字'))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else {
				if (regNum.test(value) === false) {
					callback(new Error('只能输入数字'))
				} else if (!regSP.test(value)) {
					callback(new Error('首尾不能包含空格'))
				} else {
					callback()
				}
			}
		}
    const validateImo = (rule, value, callback) => {
      if(value.length <6 || value.length > 11){
        callback(new Error('长度限制6-11位大写字母和数字'))
      } else if (regex.test(value) === false) {
				callback(new Error('请输入大写字母和数字'))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else {
				if (regex.test(value) === false) {
					callback(new Error('请输入大写字母和数字'))
				} else if (!regSP.test(value)) {
					callback(new Error('首尾不能包含空格'))
				} else {
					callback()
				}
			}
		}

		const validateEX = (rule, value, callback) => {
			if (regex.test(value) === false) {
				callback(new Error('只能输入大写字母和数字'))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else {
				if (regex.test(value) === false) {
					callback(new Error('只能输入大写字母和数字'))
				} else if (!regSP.test(value)) {
					callback(new Error('首尾不能包含空格'))
				} else {
					callback()
				}
			}
		}
    const regex2 = /^[0-9A-Z._ -]+$/
		const validateEX2 = (rule, value, callback) => {
			if (regex2.test(value) === false) {
				callback(new Error('只允许大写字母和数字、“.”、“_”、“-”、空格'))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else {
				if (regex2.test(value) === false) {
					callback(new Error('只允许大写字母和数字、“.”、“_”、“-”、空格'))
				} else if (!regSP.test(value)) {
					callback(new Error('首尾不能包含空格'))
				} else {
					callback()
				}
			}
		}
    const regex3 = /^[0-9a-zA-Z-,/.:#%&*@;'"_()\\ ]+$/
		const validateEX3 = (rule, value, callback) => {
			if (regex3.test(value) === false) {
				callback(new Error("输入不能有中文和全角字符"))
			} else if (!regSP.test(value)) {
				callback(new Error('首尾不能包含空格'))
			} else if(regNum.test(value) === true){
        callback(new Error('不允许输入纯数字'))
      } else {
				if (regex3.test(value) === false) {
					callback(new Error("输入不能有中文和全角字符"))
				} else if(regNum.test(value) === true){
          callback(new Error('不允许输入纯数字'))
        } else if (!regSP.test(value)) {
					callback(new Error('首尾不能包含空格'))
				} else {
					callback()
				}
			}
		}
    return {
      carriersList: [], // 船公司 数据
      agentList: [], // 船代 数据
      porList: [], // 港口数据
      polList: [], // 港口数据
      pouList: [], // 港口数据
      podList: [], // 港口数据
      countryList: [], // 国家数据

      imoType: false, // imo 状态
      imoTypes:'',
      imoData: {}, // imo 数据
      showGoodsDetail: false, // 货物明细
      showImo: false, // imo 弹窗
      showAgent: false, // 船代 弹窗
      selectLoading: false, // 远程搜索
      showVoyage: false, // 船名 航次 弹窗
      checkShipPlanData: '', // 船名航次 数据
      showAddress: false, // 收发通 弹窗
      addressType: '',
      showUpdateOrderFee: false, // 改单费用 弹窗
      updateOrderFee: {}, // 改单费用

      isEdit: false,
      modifyType: '',
      goodsDetailData: {
        houseBillNo: '',
        containerNo: '',
        containerSizeType: '',
        containerSn: '',
        dangerLevel: '',
        descriptionOfGoods: '',
        hsCode: '',
        marksNumber: '',
        ownContainer: '',
        packageNumber: '',
        packageUnit: '',
        sealNo: '',
        status: '',
        unCode: '',
        volume: '',
        grossWeight: '',
        packages: '',
      },

      loading:false,
      form: {
        name: '',

        masterBillNo: '', // 主题单号
        carrier: '', // 船公司
        remark: '', //客户备注

        shipName: '', // 船名
        voyageNo: '', // 航次
        shipAgent: '', // 船代
        imo: null,

        porCode: '', // 收货地
        polCode: '', // 起运港
        pouCode: '', // 卸货港
        podCode: '', // 目的港

        shipperName: '', // 发货人 信息
        shipperAddress: '',
        shipperCountryCode: '',
        shipperContactNumber: '',

        consigneeName: '', // 收货人 信息
        consigneeAddress: '',
        consigneeCountryCode: '',
        consigneeContactNumber: '',

        notifyName: '', // 通知人 信息
        notifyAddress: '',
        notifyCountryCode: '',
        notifyContactNumber: '',
        containers: [], // 箱信息
      },
      formCheck:{
        masterBillNo: [
          { required: true, message: '请输入主提单号', trigger: ['blur', 'change'] },
          { min: 6, max: 30, message: '长度过短！长度限制6-30位大写字母和数字', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX, trigger: ['blur', 'change'] }
        ],
        carrier: [{ required: true, message: '请选择船公司', trigger: ['blur', 'change'] }],
        imo: [
          { required: true, message: '请输入IMO编号', trigger: ['blur', 'change'] },
          { required: true, validator: validateImo, trigger: ['blur', 'change'] }
        ],
        shipName: [
          { required: true, message: '请输入船名', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX2, trigger: ['blur', 'change'] }
        ],
        voyageNo: [
          { required: true, message: '请输入航次', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX2, trigger: ['blur', 'change'] }
        ],
        shipAgent: [{ required: true, message: '请选择船代', trigger: ['blur', 'change'] }],
        porCode: [{ required: true, message: '请输入收货地', trigger: ['blur', 'change'] }],
        polCode: [{ required: true, message: '请输入起运港', trigger: ['blur', 'change'] }],
        pouCode: [{ required: true, message: '请输入卸货港', trigger: ['blur', 'change'] }],
        podCode: [{ required: true, message: '请输入目的港', trigger: ['blur', 'change'] }],
        shipperName: [
          { required: true, message: '请输入发货人名称', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        shipperAddress: [
          { required: true, message: '请输入发货人地址', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        shipperCountryCode: [{ required: true, message: '请输入国家代码', trigger: ['blur', 'change'] }],
        shipperContactNumber: [
          { required: true, message: '请输入发货人联系电话', trigger: ['blur', 'change'] },
          { max: 20, message: '长度过长！长度限制20个数字', trigger: ['blur', 'change'] },
          { required: true, validator: validateNum, trigger: ['blur', 'change'] }
        ],
        consigneeName: [
          { required: true, message: '请输入收货人名称', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        consigneeAddress: [
          { required: true, message: '请输入收货人地址', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        consigneeCountryCode: [{ required: true, message: '请输入国家代码', trigger: ['blur', 'change'] }],
        consigneeContactNumber: [
          { required: true, message: '请输入收货人联系电话', trigger: ['blur', 'change'] },
          { max: 20, message: '长度过长！长度限制20个数字', trigger: ['blur', 'change'] },
          { required: true, validator: validateNum, trigger: ['blur', 'change'] }
        ],
        notifyName: [
          { required: true, message: '请输入通知人名称', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        notifyAddress: [
          { required: true, message: '请输入通知人地址', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX3, trigger: ['blur', 'change'] }
        ],
        notifyCountryCode: [{ required: true, message: '请输入国家代码', trigger: ['blur', 'change'] }],
        notifyContactNumber: [
          { required: true, message: '请输入通知人联系电话', trigger: ['blur', 'change'] },
          { max: 20, message: '长度过长！长度限制20个数字', trigger: ['blur', 'change'] },
          { required: true, validator: validateNum, trigger: ['blur', 'change'] }
        ]
      },
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { label: '序号', type: 'index', width: '80px'},
          { prop: 'houseBillNo', label: '分提单号', width: '150px' },
          { prop: 'containerNo', label: '箱号', width: '150px' },
          { prop: 'sealNo', label: '封号', width: '130px' },
          { prop: 'containerType', label: '箱型', width: '100px' },
          { prop: 'descriptionOfGoods', label: '货名', width: '400px' },
          { prop: 'packages', label: '件数', width: '100px' },
          { prop: '', label: '包装单位', slotName: 'packageUnit', width: '240px' },
          { prop: 'grossWeight', label: '毛重',width: '100px' },
          { prop: 'volume', label: '体积', width: '100px' },
          { prop: 'marksNumber', label: '唛头', width: '400px' },
          { prop: 'unCode', label: '危险品code', width: '120px' },
          { prop: 'dangerLevel', label: '危险品等级', width: '100px' },
          { prop: 'dgContact', label: '危险品联系人', width: '150px' },
          { prop: 'dgContactNumber', label: '危险品联系人电话', width: '200px' },
          { prop: '', label: '操作', width: '150px', slotName: 'operation',fixed:"right"  }
        ]
      },
      WTableOptsLook: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { label: '序号', type: 'index', width: '80px'},
          { prop: 'houseBillNo', label: '分提单号', width: '150px' },
          { prop: 'containerNo', label: '箱号', width: '150px' },
          { prop: 'sealNo', label: '封号', width: '130px' },
          { prop: 'containerType', label: '箱型', width: '100px' },
          { prop: 'descriptionOfGoods', label: '货名', width: '400px' },
          { prop: 'packages', label: '件数', width: '100px' },
          { prop: '', label: '包装单位', slotName: 'packageUnit', width: '240px' },
          { prop: 'grossWeight', label: '毛重', width: '100px' },
          { prop: 'volume', label: '体积', width: '100px' },
          { prop: 'marksNumber', label: '唛头', width: '600px' },
          { prop: 'unCode', label: '危险品code', width: '150px' },
          { prop: 'dangerLevel', label: '危险品等级', width: '100px' },
          { prop: 'dgContact', label: '危险品联系人', width: '150px' },
          { prop: 'dgContactNumber', label: '危险品联系人电话', width: '200px' }
        ]
      },
      detailBack:{},
      agentData:[{}]
    }
  },
  computed: {
    carrier() {
      return this.form.carrier
    },
    getDisabled(){
      return this.detailBack.btn == 'LOOK'
    },
  },
  watch: {
    carrier(newName, oldName){
      console.log(newName)
      if(newName == 'OOCL') {
        this.imoType = true
      } else {
        this.imoType = false
      }
    }
  },
  created() {
    this.detailBack = this.$route.query;
    //解决详情页进入之后刷新页面的bug
    if(this.detailBack.btn != 'ADD'){
      if(this.detailBack.content instanceof Object){
        localStorage.setItem('detailBackData', JSON.stringify(this.detailBack))
      }else{
        this.detailBack = JSON.parse(localStorage.getItem('detailBackData'))
      }
    }
    console.log(this.detailBack, '========this.detailBack=======')
    if(this.detailBack.btn != 'ADD'){
      this.WTableOpts.data = this.detailBack.content.containers
      this.WTableOptsLook.data = this.detailBack.content.containers
      this.form = this.detailBack.content
    }
    // 复制清空主题单号和IMO
    if(this.detailBack.btn == 'COPY'){
      this.form.imo = null
      this.form.masterBillNo = ''
    }
    // 发货人国家若不存在默认CN
    if(!this.form.shipperCountryCode){
      this.form.shipperCountryCode = 'CN'
    }
    
    // 主题单号 逻辑
    let reg = /^CB[A-Z]{2}[0-9]{6}$/
    if(reg.test(this.form.masterBillNo)) {
      httpAgent({
        url: `/agent/ccam/carriers/getCarrierSimpleByMasterBillNo`,
        method: "get",
        data:{masterBillNo: this.form.masterBillNo}
      }).then((res) => {
        this.carriersList = res
      })
    } else {
      this.getCarriersList()
    }
    
    // this.getPortsList()
    this.getCountryList()
    this.form.polCode = 'CNSHA'
    this.form.porCode = 'CNSHA'
    

    console.log(this.form.porCode)
    if(this.form.porCode){
      this.getPortsList(this.form.porCode, 'porList')
    }
    if(this.form.polCode){
      this.getPortsList(this.form.polCode, 'polList')
    }
    if(this.form.pouCode){
      this.getPortsList(this.form.pouCode, 'pouList')
    }
    if(this.form.podCode){
      this.getPortsList(this.form.podCode, 'podList')
    }
    
    // 船公司存在 获取对应船代 不存在获取所有
    if(this.form.carrier){
      this.getAgentData()
    } else {
      this.getAgentList()
    }

    if(this.detailBack.btn == 'EXPORT' || this.detailBack.btn == 'EDIT'){
      setTimeout(() => {
        this.$refs['form'].validate()
      },100)
    }
  },
  methods: {
    // 主题单号失去焦点
    blurMasterBillNo(){
      let reg = /^CB[A-Z]{2}[0-9]{6}$/
      if(reg.test(this.form.masterBillNo)) {
        httpAgent({
          url: `/agent/ccam/carriers/getCarrierSimpleByMasterBillNo`,
          method: "get",
          data:{masterBillNo: this.form.masterBillNo}
        }).then((res) => {
          this.form.carrier = ''
          this.carriersList = res
        })
      } else {
        if(this.carriersList.length == 1){
          this.getCarriersList()
        }
      }
    },
    // select 失去焦点
    handBlur(val){
      console.log(val)
      this.$refs.form.validateField(val, (e) => {
        console.log(e)
      })
    },
    // 船代数据改变
    getAgentData(){
      httpAgent({
        url: `/agent/ccam/carriers/agentByCarrier`,
        method: "get",
        data:{carrier: this.form.carrier}
      }).then((res) => {
        this.agentList = res
        if(this.agentList.length == 1){
          this.form.shipAgent = this.agentList[0].code
        }
      })
    },
    // 选择船公司，对应船代改变
    changeCarrier(){
      this.form.shipAgent = ''
      this.form.imo = null
      this.getAgentData()
      this.getPortsList()
    },  
    // 确认发送修改报文
    enterSendUpdateOrder(data){
      let param = {
        fee: data.fee,
        houseBill: data.houseBill
      }
      httpAgent({
        url: `/agent/ccam/orders/updateSend`,
        method: "post",
        data:param
      }).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.toBack();
      })
    },
    // 发送修改报文 确认费用
    sendUpdateOrder(){
      httpAgent({
        url: `/agent/ccam/orders/checkUpdateFee`,
        method: "get",
        data:{houseBillId: this.detailBack.content.id}
      }).then((res) => {
        this.showUpdateOrderFee = true
        this.updateOrderFee = { ...res, houseBill: this.form }
      })
    },
    // 选择收发通
    chooseAddress(type){
      this.addressType = type
      this.showAddress = true
    },
    // 选择客户
    chooseSuccess(custom){
      if(custom.addressType == 1){
        this.form.shipperAddress = custom.address
        this.form.shipperContactNumber = custom.contact
        this.form.shipperCountryCode = custom.countryCode
        this.form.shipperName = custom.customerName
      }
      if(custom.addressType == 2){
        this.form.consigneeAddress = custom.address
        this.form.consigneeContactNumber = custom.contact
        this.form.consigneeCountryCode = custom.countryCode
        this.form.consigneeName = custom.customerName
      }
      if(custom.addressType == 3){
        this.form.notifyAddress = custom.address
        this.form.notifyContactNumber = custom.contact
        this.form.notifyCountryCode = custom.countryCode
        this.form.notifyName = custom.customerName
      }
    },
    // 复制收货人
    copyConsignee(){
      this.form.notifyAddress = this.form.consigneeAddress
      this.form.notifyContactNumber = this.form.consigneeContactNumber
      this.form.notifyCountryCode = this.form.consigneeCountryCode
      this.form.notifyName = this.form.consigneeName

    },
    // 保存客户
    saveCustoms(custom){
      let params = {}
      let formName = '';
      if(custom == 1){
        params = {
          address: this.form.shipperAddress,
          contact: this.form.shipperContactNumber,
          countryCode: this.form.shipperCountryCode,
          customerName: this.form.shipperName,
          type: 0,
        }
        formName = 'shipperForm'
      }
      if(custom == 2){
        params = {
          address: this.form.consigneeAddress,
          contact: this.form.consigneeContactNumber,
          countryCode: this.form.consigneeCountryCode,
          customerName: this.form.consigneeName,
          type: 0,
        }
        formName = 'consigneeForm'
      }
      if(custom == 3){
        params = {
          address: this.form.notifyAddress,
          contact: this.form.notifyContactNumber,
          countryCode: this.form.notifyCountryCode,
          customerName: this.form.notifyName,
          type: 0,
        }
        formName = 'notifyForm'
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          httpAgent({
            url: `/agent/ccam/customs`,
            method: "post",
            data:params
          }).then((res) => {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          })
        }
      })
      
    },
    
    // 查看船代
    findAgent(){
      if(!this.form.carrier){
        this.$message({
          message: '请选择船公司',
          type: 'error'
        })
        return
      }
      if(!this.form.shipName){
        this.$message({
          message: '请输入船名',
          type: 'error'
        })
        return
      }
      if(!this.form.voyageNo){
        this.$message({
          message: '请输入航次',
          type: 'error'
        })
        return
      }
      let param = {
        shipName: this.form.shipName,
        voyageNo: this.form.voyageNo,
        carrier: this.form.carrier
      }
      httpAgent({
        url: `/agent/ccam/drafts/validateShipInfo`,
        method: "get",
        data:param
      }).then((res) => {
        this.agentData[0].shipStatus = res.queryStatus
        this.agentData[0].shipAgent = res.code
        this.agentData[0].shipAgentName = res.name
        this.agentData[0].carrier = this.form.carrier
        this.agentData[0].shipName = this.form.shipName
        this.agentData[0].voyageNo = this.form.voyageNo
        this.showAgent = true
      })
    },
    // 校验船名航次
    checkShipPlan(){
      if(!this.form.shipName){
        this.$message({
          message: '请输入船名',
          type: 'error'
        })
        return
      }
      if(!this.form.voyageNo){
        this.$message({
          message: '请输入航次',
          type: 'error'
        })
        return
      }
      let param = {
        shipName: this.form.shipName,
        voyageNo: this.form.voyageNo
      }
      httpAgent({
        url: `/agent/ccam/drafts/checkShipPlan`,
        method: "get",
        data:param
      }).then((res) => {
        this.checkShipPlanData = res
        this.showVoyage = true
      })
    },
    // 保存到待发送
    saveSent() {
      this.$refs['form'].validate((valid) => {
        console.log(valid)
        if(valid){
          let params = { ...this.form, containers: this.WTableOpts.data}

          if(this.detailBack.btn == 'EDIT' && this.detailBack.type == 'WAITING'){
            httpAgent({
              url: `/agent/ccam/drafts/${this.detailBack.id}`,
              method: "put",
              data:{
                content: params,
                type: 'WAITING',
                id: this.detailBack.id
              }
            }).then((res) => {
              this.toBack();
            })
          } else {
            console.log(this.detailBack)
            if(this.detailBack.id && this.detailBack.btn != 'COPY'){
              httpAgent({
                url: `/agent/ccam/drafts/${this.detailBack.id}`,
                method: "put",
                data:{
                  content: params,
                  type: 'WAITING',
                  id: this.detailBack.id
                }
              }).then((res) => {
                this.toBack();
              })
            } else {
              httpAgent({
                url: `/agent/ccam/drafts`,
                method: "post",
                data:{
                  content: params,
                  type: 'WAITING'
                }
              }).then((res) => {
                console.log(res)
                this.toBack();
              })
            }
            
          }
        } else {
          this.$message({
            message: '还有数据错误，请修改',
            type: 'error'
          })
        }
      })
    },
    // 保存草稿
    saveDraft(){
      let params = { ...this.form, containers: this.WTableOpts.data}
      console.log(this.detailBack)
      if(this.detailBack.btn == 'EDIT' && this.detailBack.type == 'DRAFT'){
        httpAgent({
          url: `/agent/ccam/drafts/${this.detailBack.id}`,
          method: "put",
          data:{
            content: params,
            type: 'DRAFT',
            id: this.detailBack.id
          }
        }).then((res) => {
          this.toBack();
        })
      } else {
        httpAgent({
          url: `/agent/ccam/drafts`,
          method: "post",
          data:{
            content: params,
            type: 'DRAFT'
          }
        }).then(() => {
          this.toBack();
        })
      }
    },
    // 箱货明细增加
    submitGoods(data){
      this.showGoodsDetail = false
      if(data.index >= 0){
        this.WTableOpts.data.splice(data.index,1,data)
      } else {
        this.WTableOpts.data.push(data)
      }
    },
     // 新增货物明细
    addGoodsDetail(){
      this.showGoodsDetail = true
      this.isEdit = false
      this.modifyType = ''
      this.goodsDetailData = {}
    },
    // 复制 
    copyData(row){
      let data = { ...row }
      this.WTableOpts.data.push(data)
    },
    // 编辑
    editData(row, index){
      if(this.detailBack.btn == 'UPDATE') {
        this.modifyType = 'UPDATE'
      }
      this.showGoodsDetail = true
      this.goodsDetailData = { ...row, index: index, type: 'UPDATE'}
    },
    // 删除 
    deleteData(row, index){
      this.$confirm('此操作将删除该数据, 是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.WTableOpts.data.splice(index, 1)
      }).catch(()=>{})
    },
     // 收货地
    changePor(val){
      this.form.porCode = val
    },
    remoteMethodPor(query){
      this.getPortsList(query, 'porList')
    },
    // 起运港
    changePol(val){
      this.form.polCode = val
    },
    remoteMethodPol(query){
      this.getPortsList(query, 'polList')
    },
    // 卸货港
    changePou(val){
      this.form.pouCode = val
    },
    remoteMethodPou(query){
      this.getPortsList(query, 'pouList')
    },
    // 目的港
    changePod(val){
      this.form.podCode = val
    },
    remoteMethodPod(query){
      this.getPortsList(query, 'podList')
    },
    // 国家
    changeCountry(val){
      this.form.shipperCountryCode = val
    },
    remoteMethodCountry(query){
      this.getCountryList(query, 'sCountry')
    },
    // 获取 所有国家数据
    getCountryList(val, type){
      httpAgent({
        url: `/agent/enums/country`,
        method: "get",
      }).then((res) => {
        this.countryList = res
      })
    },
    // 查询IMO
    searchImo(){
      if(!this.form.shipName) {
        this.$message({
          message: '请输入船名',
          type: 'error'
        })
        return
      }
      let param = {
        shipName: this.form.shipName,
        carrier: this.form.carrier
      }
      httpAgent({
        url: `/agent/ccam/drafts/queryShipImo`,
        method: "get",
        data:param
      }).then((res) => {
        this.showImo = true
        if(res){
          this.imoData = res
        } else {
          this.imoTypes = '3'
        }
      })
    },
    // 确认IMO
    enterImo(row){
      console.log(row)
      this.form.imo = row.imo
    },
    
    
    
    
    
    // 获取船公司
    getCarriersList(){
      httpAgent({
        url: `/agent/ccam/carriers/simple`,
        method: "get",
      }).then((res) => {
        this.carriersList = res
      })
    },
    // 获取船代
    getAgentList(){
      httpAgent({
        url: `/agent/ccam/carriers/agent`,
        method: "get",
      }).then((res) => {
        this.agentList = res
        if(this.agentList.length == 1){
          this.form.shipAgent = this.agentList[0].code
        }
      })
    },
    // 获取港口
    getPortsList(val, type){
      console.log(val);
      this.selectLoading = true
      if(val && val.length > 128) val = ''
      let params = {
        pageNum: 1,
        pageSize: 50,
        carrierCode: this.form.carrier,
        codeLike: val ? val : '',
        countryCnNameLike: val ? val : '',
        countryCodeLike: val ? val : '',
        countryEnNameLike: val ? val : '',
        nameCnLike: val ? val : '',
        nameEnLike: val ? val : '',
      }
      httpAgent({
        url: `/agent/ccam/ports/simpleLikeOr`,
        method: "get",
        data:params
      }).then((res) => {
        if(type) {
          this[type] = res.records
        } else {
          this.porList = res.records
          this.polList = res.records
          this.pouList = res.records
          this.podList = res.records
        }
      }).finally(() => {
        this.selectLoading = false
      })
    },
    // 返回上一层
    toBack(){
      //this.$emit('detailReturn', this.detailBack)
      this.$router.back();
    },
    // 关闭弹窗
    closeDialog(){
      this.modifyType = ''
      this.showImo = false
      this.showGoodsDetail = false
      this.showAgent = false
      this.showVoyage = false
      this.showAddress = false
      this.showUpdateOrderFee = false
    },
    //查看船代选择的船代回显
    chooseAgent(shipAgent){
      this.form.shipAgent = shipAgent;
    },
    // 获取总件数
		getTotalPackages (containers) {
			if (containers.length <= 0) return 0
			let totalPackage = 0
			for (let i = 0; i < containers.length; i++) {
				totalPackage += Number(containers[i].packages ? containers[i].packages : 0)
			}
			return totalPackage
		},

		// 获取总体积
		getTotalVolume (containers) {
			if (containers.length <= 0) return 0

			let totalVolume = 0
			for (let i = 0; i < containers.length; i++) {
				totalVolume += Number(containers[i].volume ? containers[i].volume : 0)
			}
			return totalVolume.toFixed(3)
		},

		// 获取总毛重
		getTotalGrossWeight (containers) {
			if (containers.length <= 0) return 0

			let totalGrossWeight = 0
			for (let i = 0; i < containers.length; i++) {
				totalGrossWeight += Number(containers[i].grossWeight ? containers[i].grossWeight : 0)
			}
			return totalGrossWeight.toFixed(3)
		},
    // 转大写
    toupcaseTable (val, id, index) {
      this.form[id] = val.toUpperCase()
    },
    
  }
}
</script>

<style scoped lang="less">
.detail {
  font-size: 14px;
  background: #ffffff;
  border-radius: 4px;
  padding: 24px 48px 24px 24px;
  color: #333333;

  .page-title-box {
    height: 32px;
    line-height: 32px;
    margin-bottom: 24px;
    text-align: right;
    .page-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      float: left;
    }
  }
  .form-part {
    height: 36px;
    background: linear-gradient(90deg, #eaf4fe 0%, rgba(198, 225, 253, 0) 100%);
    border-radius: 4px;
    line-height: 36px;
    padding-left: 24px;
    margin: 8px 0 24px 0;
  }
  .el-form {
    .el-form-item {
      margin: 0 0 16px 24px;
    }
    .form-item-btn {
      width: 108px;
      margin-left: 16px;
    }
    .good-user-link {
      .iconfont {
        font-size: 12px;
        margin-right: 6px;
        margin-left: 24px !important;
      }
    }
    .good-user-link + .good-user-link {
      .iconfont {
        margin-left: 16px;
      }
    }
    .goods-list-title {
      min-width: 352px;
      height: 32px;
      background: linear-gradient(270deg, #ffffff 0%, #f5f9ff 100%);
      border-radius: 4px;
      line-height: 32px;
      padding-left: 16px;
      box-sizing: border-box;
      float: right;
      .goods-num {
        color: #1170eb;
        min-width: 50px;
        display: inline-block;
        text-align: center;
        padding-right: 6px;
      }
    }
  }
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
  }
}
</style>